const revenueChart = {
    series: [{
        name: 'Pedidos',
        data: [42, 85, 101, 56, 37, 105]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '14%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
        },
        yaxis: {
            title: {
                text: 'contagem'
            }
        },
        fill: {
            opacity: 1

        },
        colors: ['#556ee6'],
    }
};

export { revenueChart };